export default __webpack_public_path__ + "images/72d6fc0545b500086cf52278edd8f3c7.jpg";